import React from 'react'
import PropTypes from 'prop-types'

import Config from 'configs'

import { SOURCE_PRINT_MODAL } from './constants'
import { AwbPrinterModalV1 } from './AwbPrinterModalV1'
import { AwbPrinterModalV2 } from './AwbPrinterModalV2'
import { TYPE } from 'containers/FPLOrderDetails/constants'

// Enum for AWB modal types
export const AWB_MODAL_TYPE = {
  V1: 'V1',
  V2: 'V2'
}

export const PrintAwbModal = props => {
  const awbModalType =
    (Config.FPL_SHOWING_NEW_AWB_VERSION === 'true' && props.parcelType === TYPE.PARCEL) ||
    props.parcelType === TYPE.B2B_BUNDLE

  if (awbModalType) {
    return (
      <AwbPrinterModalV2
        {...props}
        enabledPortrait={props.parcelType === TYPE.B2B_BUNDLE}
        modalType={AWB_MODAL_TYPE.V2}
      />
    )
  }
  return <AwbPrinterModalV1 {...props} modalType={AWB_MODAL_TYPE.V1} trackingIds={props.parcelIds} />
}

PrintAwbModal.propTypes = {
  batchId: PropTypes.number,
  onCancel: PropTypes.func.isRequired,
  totalOrderCount: PropTypes.number,
  trackingIds: PropTypes.arrayOf(PropTypes.string),
  parcelIds: PropTypes.arrayOf(PropTypes.number),
  visible: PropTypes.bool,
  source: PropTypes.string,
  orders: PropTypes.array,
  countryVendor: PropTypes.string,
  parcelType: PropTypes.number
}

PrintAwbModal.defaultProps = {
  visible: false,
  source: SOURCE_PRINT_MODAL.LIST,
  orders: []
}
